module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /Users/alex/Documents/JC/JC3 3/src/app/shared/layout/app-layouts/empty-layout.component.html
// module id = ../../../../../src/app/shared/layout/app-layouts/empty-layout.component.html
// module chunks = main